export default __webpack_public_path__ + "static/media/Arrow.80ac6385.svg";